import { Theme } from '@styles/DefaultTheme';
import React, { ComponentPropsWithoutRef } from 'react';
import styled, { keyframes } from 'styled-components';

interface ISkeletonBox extends ComponentPropsWithoutRef<'div'> {
	_width: string;
	_height: string;
	radius?: string;
	delay?: string;
	_margin?: string;
}

const CoreSkeletonBox = ({
	_width,
	_height,
	radius,
	delay,
	_margin,
	...props
}: ISkeletonBox) => {
	return (
		<Box
			_width={_width}
			_height={_height}
			radius={radius}
			delay={delay}
			_margin={_margin}
			{...props}
		/>
	);
};

const skeleton_ani = keyframes`
    0% {
      background-color: ${Theme.colors.gray.gray10};
    }
    50% {
      background-color: ${Theme.colors.gray.gray15};
    }
    100% {
      background-color: ${Theme.colors.gray.gray10};
    }
`;

const Box = styled.div<{
	_width: string;
	_height: string;
	radius?: string;
	_margin?: string;
	delay?: string;
}>`
	width: ${({ _width }) => _width};
	height: ${({ _height }) => _height};
	flex-shrink: 0;
	${({ radius }) => radius && `border-radius: ${radius}`};
	${({ _margin }) => _margin && `margin: ${_margin}`};
	background-color: ${({ theme }) => theme.colors.gray.gray10};
	animation: ${skeleton_ani} 6s infinite ease-in-out;
	${({ delay }) => delay && `animation-delay: ${delay}`};
`;

export default CoreSkeletonBox;
